import { useContext } from "react";
import { AbilityContext } from "./Can";

export const useAbilityContext = () => {
  const context = useContext(AbilityContext);
  return context;
};
